<template>
  <Wrapper
    ref="wrapper"
    type-list="followers"
    :item-source="fetchFollowers"
    :popover-position-target="popoverPositionTarget"
    :popover-items="items"
    :dummy-props="{
      headerText: $t(
        '_web_account-list_dummy_followers',
        'You have no followers at the moment'
      ),
      text: $t(
        '_web_account-list_dummy_followers_subheader',
        'We believe that they will appear soon'
      ),
    }"
    @hidePopover="popoverPositionTarget = null"
  >
    <ListItemAccount
      :key="
        user.login +
          user.social_metadata.is_follow +
          user.social_metadata.is_friend_requested
      "
      slot-scope="{ user }"
      v-bind="{
        type: user.type,
        avatar: user.avatar,
        name: $filters.displayName(user),
        accountId: user.login,
        approved: user.approved,
        vanityId: user.vanityId || user.vanity_id,
      }"
      class="mb-3 py-2 pl-5 pr-5"
    >
      <div
        v-if="account._canEdit && myAccountId !== user.login"
        slot="action"
        class="d-flex align-items-center"
      >
        <FollowBtn
          v-if="hasAccessByPermission('followProfile')"
          :model="createAccountModel(user)"
          class="h-mr-3"
          @toggleFollow="isFollow => toggleFollow(isFollow, user)"
        />
        <AppIcon
          name="dots"
          class="cursor-pointer px-3 py-4 followers-smalls"
          :class="{ disabled: !canAddToFriend(user) }"
          :fill="$scss.heraMuted"
          :hover-fill="$scss.hoverColor"
          @click.stop="event => dotsClickHandler(event, user)"
        />
      </div>
    </ListItemAccount>
  </Wrapper>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import { friendRequest } from '@/mixins/accountActions/profile';
import AppIcon from '@/components/atoms/Icon';
import ListItemAccount from '@/components/common/ListItemAccount';
import Wrapper from '../ListWrapper';
import FollowBtn from '@/components/common/FollowBtn';
import { PROFILE } from '@/constants/accounts';
import AccountModel from '@/models/Account';

export default {
  name: 'AccountFollowers',
  components: {
    Wrapper,
    ListItemAccount,
    FollowBtn,
    AppIcon,
  },
  mixins: [friendRequest],
  data() {
    return {
      items: null,
      popoverPositionTarget: null,
    };
  },
  computed: {
    ...mapState('current', ['account']),
    ...mapState('my', { myAccount: 'account', myAccountId: 'accountId' }),
    ...mapGetters(['hasAccessByPermission']),
  },
  methods: {
    ...mapActions(['fetchFollowers']),
    canAddToFriend(user) {
      return this.hasAccessByPermission('addToFriend') && user.type === PROFILE;
    },
    getAccountSocial(user) {
      const social = user.social_metadata;

      return {
        isFollow: social.is_follow,
        isFriend: social.is_friend,
        isFriendRequested: social.is_friend_requested,
        isFriendRequestedBy: social.is_friend_requested_by,
      };
    },
    toggleFollow(isFollow, user) {
      this.$set(user['social_metadata'], 'is_follow', isFollow);
      this.myAccount.updateCounters({
        following: isFollow ? +1 : -1,
      });
    },

    toggleFriends(user) {
      this.friendRequestProfileAction({
        socials: this.getAccountSocial(user),
        accountId: user.login,
        accountType: user.type,
      })
        .then(
          ({
            isFriend,
            isFriendRequested,
            isFriendRequestedBy,
            isFollow,
            addedToFriend,
            removedToFriend,
          } = {}) => {
            this.$refs.wrapper.updateUser({
              ...user,
              social_metadata: {
                ...user.social_metadata,
                is_follow: isFollow,
                is_friend: isFriend,
                is_friend_requested: isFriendRequested,
                is_friend_requested_by: isFriendRequestedBy,
              },
            });
            this.myAccount.updateCounters({
              friends: addedToFriend ? +1 : removedToFriend ? -1 : 0,
            });
          }
        )
        .finally(() => {
          this.popoverPositionTarget = null;
        });
    },

    dotsClickHandler(event, user) {
      this.items = [
        {
          label: this.friendRequestProfileText({
            socials: this.getAccountSocial(user),
          }),
          action: this.toggleFriends.bind(this, user),
          loading: this.waitingFriendRequest,
        },
        // {
        //   label: this.reportProfileText(),
        //   action: () => this.reportProfileAction(),
        //   loading: this.waitingReportRequest,
        // },
      ];
      this.popoverPositionTarget = event.target;
    },

    createAccountModel(user) {
      return new AccountModel(user.type, user.login).update(user);
    },
  },
};
</script>
<style lang="scss">
@media (max-width: 767px) {
  .followers-smalls {
    display: none;
  }
}
</style>
